var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.958 19.778c-.428.28-.862.295-1.3.047C7.218 19.578 7 19.197 7 18.68V5.32c0-.516.22-.898.657-1.146.44-.247.873-.23 1.301.049l10.464 6.68c.385.258.578.624.578 1.097s-.193.84-.578 1.097l-10.464 6.68Z","fill":"currentColor"}));
}

Play.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Play;

Play.default = Play;
